<div class="card-container">
    <ng-container *ngFor="let user of users; let userIndex = index">
        <div class="user-card ccc">
            <div class="d-flex justify-content-end">
                <button class="btn delete-btn delete-btn-circle"
                    (click)="deleteUser(user.userId)">
                    <i class="app-icon icon icon-delete icon-lg"></i>
                </button>
            </div>

            <div class="card-item card-name cursor-pointer" (click)="viewDetails(user.userId)">
                <dynamic-field [props]="props?.Name" [canBeEmpty]="true">
                    <span HJSuppress class="number">{{user.name}}</span>
                </dynamic-field>
            </div>

            <div class="card-item card-email">
                <dynamic-field [props]="props?.Email" [canBeEmpty]="true">
                    <span HJSuppress class="number">{{user.email}}</span>
                </dynamic-field>
            </div>

            <div class="card-item card-phone">
                <dynamic-field [props]="props?.Phone" [canBeEmpty]="true">
                    <span HJSuppress class="number">{{user.phone}}</span>
                </dynamic-field>
            </div>

            <div class="card-item card-switcher">
                <dynamic-field [props]="props?.IsActive" [canBeEmpty]="true">
                    <kendo-switch [(ngModel)]="user.isActive"
                        name="users-switch-{{userIndex}}"
                        (valueChange)="changeUserStatus(user.userId, $event)"
                    >
                    </kendo-switch>
                </dynamic-field>
            </div>

            <div class="card-item d-flex justify-content-center gap-2">
                <button class="btn delete-btn gap-2" [disabled]="!user.isActive"
                    (click)="user.isActive && viewDetails(user.userId)">
                    <i class="app-icon icon icon-edit icon-lg"></i>
                    <span>{{'users.add.placeholder.userDetails' | translate}}</span>
                </button>
            
                <div class="divider"></div>
            
                <button class="btn delete-btn gap-2" [disabled]="!user.isActive"
                    (click)="user.isActive && redirectUserRights(user.userId)">
                    <i class="app-icon icon icon-edit icon-lg"></i>
                    <span>{{'users.add.placeholder.userRights' | translate}}</span>
                </button>
            </div>
        </div>
    </ng-container>
</div>
